enum COOKIES {
  correspondingEventId = 'vdp-corresponding-event-id',
  dataDogSampling = '_dd_s',
  nativeAppCapabilities = 'X-CVNA-AppCapabilities-VDP',
  nativeAppVersion = 'X-CVNA-AppVersion',
  nativeHomeInView = 'nativeHomeInView',
  searchRequestId = 'searchRequestId',
  tradeInApplied = 'merch-tradein-applied'
}

export default COOKIES;
